import api from '../../services/api';

/** An index the admin picks when adding surplus by hand; the data comes from its newest production item. */
export interface SurplusIndex {
  index: string;
  name: string | null;
  material: string | null;
  color: string | null;
  dye: string | null;
}

export const searchSurplusIndexes = async (q: string): Promise<SurplusIndex[]> =>
  (await api.get('/surplus/indexes', { params: { q: q || undefined } })).data.data;

export const addPackingSurplus = (index: string, quantity: number) => api.post('/packing/surplus', { index, quantity });

export const removePackingSurplus = (requestId: number) => api.delete(`/packing/surplus/${requestId}`);

export const addMaterialSurplus = (index: string, quantity: number) => api.post('/warehouse/surplus/manual', { index, quantity });

export const removeMaterialSurplus = (id: number) => api.delete(`/warehouse/surplus/manual/${id}`);
